// src/demo/brandProfile.js

const HEX_COLOR = /^#[0-9A-F]{6}$/i;

// localStorage carrier for the (potentially large) logo data URI. URL-encoded
// brand profiles get embedded as query params on iframe srcs and can blow past
// the dev server's 8KB request-header limit (HTTP 431) once a real wordmark is
// scraped. Keeping the heavy field out of the URL keeps the encoded string
// well under any header cap.
const LOGO_STORAGE_PREFIX = 'demo:brandLogo:';

// base64url: URL-safe variant. Standard base64 uses +, /, = which collide
// with URL semantics (in particular, + decodes as space in URLSearchParams).
function base64UrlEncode(str) {
  return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

function base64UrlDecode(str) {
  let padded = str.replace(/-/g, '+').replace(/_/g, '/');
  while (padded.length % 4) padded += '=';
  return atob(padded);
}

export function encodeBrandProfile(profile) {
  if (profile?.logoDataUri && profile.domain) {
    try {
      localStorage.setItem(LOGO_STORAGE_PREFIX + profile.domain, profile.logoDataUri);
    } catch {
      /* storage full / disabled — decode just won't restore the logo */
    }
  }
  const slim = { ...profile, logoDataUri: null };
  return base64UrlEncode(encodeURIComponent(JSON.stringify(slim)));
}

export function decodeBrandProfile(encoded) {
  if (!encoded || typeof encoded !== 'string') return null;
  let parsed;
  try {
    parsed = JSON.parse(decodeURIComponent(base64UrlDecode(encoded)));
  } catch {
    return null;
  }
  if (parsed?.domain) {
    try {
      const logo = localStorage.getItem(LOGO_STORAGE_PREFIX + parsed.domain);
      if (logo) parsed.logoDataUri = logo;
    } catch {
      /* ignore */
    }
  }
  return parsed;
}

export function isValidBrandProfile(profile) {
  if (!profile || typeof profile !== 'object') return false;
  if (typeof profile.storeName !== 'string' || profile.storeName.length === 0) return false;
  if (typeof profile.primaryColor !== 'string' || !HEX_COLOR.test(profile.primaryColor)) return false;
  if (typeof profile.secondaryColor !== 'string' || !HEX_COLOR.test(profile.secondaryColor)) return false;
  if (typeof profile.domain !== 'string') return false;
  if (typeof profile.verified !== 'boolean') return false;
  if (profile.logoDataUri != null && typeof profile.logoDataUri !== 'string') return false;
  return true;
}
